
// 生产
export let baseUrl = 'https://hole-api.linzc.cn';
// 开发
// export let baseUrl = 'http://127.0.0.1:8000';

